import { cx } from "class-variance-authority"
import { useHits } from "react-instantsearch-hooks-web"
import React from "react"
import { OfferTeaserMapper, OfferAlgoliaSearchResult } from ".."
import { OfferTeaser } from "../../offers"
import { OfferListLoader } from "../../page/offers/list/OfferListLoader"
import { AlgoliaPagination } from "../AlgoliaPagination"
import { ActiveMapOffer } from "../../page/offers/list/map/ActiveMapOffer"

export const OfferSearchList = ({
  isMap = false,
}: {
  isMap?: boolean
}) => {
  const { results } = useHits<OfferAlgoliaSearchResult>()
  return (
    <div className="relative mx-auto space-y-4 lg:space-y-8">
      <ol className="space-y-4">
        {results?.hits.length && results?.hits.length > 0 ? results?.hits.map((hit, index) => (
          <li
            key={hit.slug}
            className={cx(
              'transition-transform transform-gpu duration-100 md:duration-500 ease-out opacity-0',
              'translate-y-4 animate-slide-in',
              'scale-95 animate-zoom-in',
              'animate-fade-in',
            )}
            style={{ animationDelay: `${index * 100}ms` }}
          >
            {isMap ?
              <ActiveMapOffer offer={hit} setUnactive={() => undefined} />
              : <OfferTeaser {...OfferTeaserMapper({ hit })} />}
          </li>
        )) : (
          <OfferListLoader nbOffers={20} />
        )}
      </ol>

      <AlgoliaPagination />
    </div>
  )
}
